let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kCm1W")).then(() => parcelRequire('jXQF4'));